'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _reactackleTooltipIcon = require('reactackle-tooltip-icon');

var _CheckboxStyled = require('./styles/CheckboxStyled');

var _CheckboxElementStyled = require('./styles/CheckboxElementStyled');

var _CheckboxInputStyled = require('./styles/CheckboxInputStyled');

var _CheckboxLabelStyled = require('./styles/CheckboxLabelStyled');

var _LabelElementStyled = require('./styles/LabelElementStyled');

var _LabelTextStyled = require('./styles/LabelTextStyled');

var _MessageStyled = require('./styles/MessageStyled');

var _CheckboxIcon = require('./CheckboxIcon');

var _CheckboxIcon2 = _interopRequireDefault(_CheckboxIcon);

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('checkbox', _theme2.default);
var propTypes = {
  /**
   * Determines whether to check Checkbox by default
   */
  defaultChecked: _propTypes2.default.bool,

  /**
   * Determines Checkbox checked state
   */
  checked: _propTypes2.default.bool,

  /**
   * Determines whether to disable checkbox
   */
  disabled: _propTypes2.default.bool,

  /**
   * Label of Checkbox
   */
  label: _propTypes2.default.string,

  /**
   * Label Component
   */
  labelElement: _propTypes2.default.element,

  /**
   * Add tooltip
   */
  tooltip: _propTypes2.default.string,

  /**
   * Pass error message
   */
  errorMessage: _propTypes2.default.string,

  /**
   * Specify function that will be called on Checkbox checked state change
   */
  onChange: _propTypes2.default.func
};
var defaultProps = {
  defaultChecked: false,
  checked: void 0,
  disabled: false,
  label: '',
  tooltip: '',
  errorMessage: '',
  labelElement: null,
  onChange: _reactackleCore.noop
};
var nextId = 0;

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    _this._inputId = 'checkbox-' + nextId++;
    _this.state = {
      checked: (0, _reactackleCore.isUndef)(props.checked) ? props.defaultChecked : props.checked,
      focused: false
    };
    _this._handleChange = _this._handleChange.bind(_this);
    _this._handleFocus = _this._handleFocus.bind(_this);
    _this._handleBlur = _this._handleBlur.bind(_this);
    _this._changeCheckedState = _this._changeCheckedState.bind(_this);
    _this._keyboardListener = _this._keyboardListener.bind(_this);
    return _this;
  }

  _createClass(Checkbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.checked !== this.props.checked && (0, _reactackleCore.isUndef)(nextProps.checked)) {
        this.setState({
          checked: this.props.checked
        });
      }

      var isDefaultValueChanged = nextProps.defaultChecked !== this.props.defaultChecked;

      if (isDefaultValueChanged) {
        this.setState({
          checked: nextProps.defaultChecked
        });
      }
    }
  }, {
    key: '_handleChange',
    value: function _handleChange(event) {
      this._changeCheckedState(event.target.checked);
    }
  }, {
    key: '_changeCheckedState',
    value: function _changeCheckedState(checked) {
      if ((0, _reactackleCore.isUndef)(this.props.checked)) {
        this.setState({
          checked: checked
        });
      }

      this.props.onChange({
        value: checked
      });
    }
  }, {
    key: '_handleFocus',
    value: function _handleFocus() {
      this._toggleKeyboardListener(true);

      this.setState({
        focused: true
      });
    }
  }, {
    key: '_handleBlur',
    value: function _handleBlur() {
      this._toggleKeyboardListener(false);

      this.setState({
        focused: false
      });
    }
  }, {
    key: '_keyboardListener',
    value: function _keyboardListener(e) {
      var key = e.keyCode || e.which;

      if (key === _reactackleCore.keyboardCodes.SPACE) {
        this._changeCheckedState(!this.state.checked);
      }
    }
  }, {
    key: '_toggleKeyboardListener',
    value: function _toggleKeyboardListener(condition) {
      if (condition) {
        document.addEventListener('keypress', this._keyboardListener);
      } else {
        document.removeEventListener('keypress', this._keyboardListener);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var checked = (0, _reactackleCore.isUndef)(this.props.checked) ? this.state.checked : this.props.checked;
      var tooltip = this.props.tooltip && (this.props.label || this.props.labelElement) ? _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, {
        text: this.props.tooltip
      }) : null;
      var label = this.props.label ? _react2.default.createElement('span', null, _react2.default.createElement(_LabelTextStyled.LabelTextStyled, {
        hasTooltip: !!this.props.tooltip
      }, this.props.label), tooltip) : null;
      var labelElement = this.props.labelElement ? _react2.default.createElement(_LabelElementStyled.LabelElementStyled, {
        hasTooltip: !!this.props.tooltip
      }, this.props.labelElement, tooltip && _react2.default.createElement(_LabelTextStyled.LabelTextStyled, null, tooltip)) : null;
      var checkboxIcon = !this.props.label && !this.props.labelElement ? _react2.default.createElement(_CheckboxIcon2.default, {
        disabled: this.disabled,
        checked: checked,
        tooltipText: this.props.tooltip
      }) : _react2.default.createElement(_CheckboxIcon2.default, {
        disabled: this.props.disabled,
        checked: checked
      });
      var message = this.props.errorMessage ? _react2.default.createElement(_MessageStyled.MessageStyled, null, this.props.errorMessage) : null;
      return _react2.default.createElement(_CheckboxStyled.CheckboxStyled, null, _react2.default.createElement(_CheckboxElementStyled.CheckboxElementStyled, {
        textFree: !this.props.label && !this.props.labelElement
      }, _react2.default.createElement(_CheckboxInputStyled.CheckboxInputStyled, {
        id: this._inputId,
        type: 'checkbox',
        checked: checked,
        disabled: this.disabled,
        onChange: this._handleChange,
        tabIndex: -1
      }), _react2.default.createElement(_CheckboxLabelStyled.CheckboxLabelStyled, {
        textFree: !this.props.label && !this.props.labelElement,
        disabled: this.disabled,
        checked: checked,
        htmlFor: this._inputId,
        tabIndex: this.disabled ? -1 : 0,
        onFocus: this._handleFocus,
        onBlur: this._handleBlur
      }, checkboxIcon, label, labelElement)), message);
    }
  }, {
    key: 'disabled',
    get: function get() {
      return this.props.disabled || !!this.props.errorMessage;
    }
  }]);

  return Checkbox;
}(_react.Component);

exports.default = Checkbox;
Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
Checkbox.displayName = 'Checkbox';